"use strict";

var _classCallCheck = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/build_b87ea1ca/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var DOMException = require("domexception/webidl2js-wrapper");

var _require = require("../../utils"),
    mixin = _require.mixin;

var NodeImpl = require("./Node-impl").implementation;

var ChildNodeImpl = require("./ChildNode-impl").implementation;

var NonDocumentTypeChildNodeImpl = require("./NonDocumentTypeChildNode-impl").implementation;

var _require2 = require("../node-type"),
    TEXT_NODE = _require2.TEXT_NODE;

var _require3 = require("../helpers/mutation-observers"),
    MUTATION_TYPE = _require3.MUTATION_TYPE,
    queueMutationRecord = _require3.queueMutationRecord; // https://dom.spec.whatwg.org/#characterdata


var CharacterDataImpl =
/*#__PURE__*/
function (_NodeImpl) {
  _inherits(CharacterDataImpl, _NodeImpl);

  function CharacterDataImpl(globalObject, args, privateData) {
    var _this;

    _classCallCheck(this, CharacterDataImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CharacterDataImpl).call(this, globalObject, args, privateData));
    _this._data = privateData.data;
    return _this;
  } // https://dom.spec.whatwg.org/#dom-characterdata-data


  _createClass(CharacterDataImpl, [{
    key: "substringData",
    // https://dom.spec.whatwg.org/#dom-characterdata-substringdata
    // https://dom.spec.whatwg.org/#concept-cd-substring
    value: function substringData(offset, count) {
      var length = this.length;

      if (offset > length) {
        throw DOMException.create(this._globalObject, ["The index is not in the allowed range.", "IndexSizeError"]);
      }

      if (offset + count > length) {
        return this._data.slice(offset);
      }

      return this._data.slice(offset, offset + count);
    } // https://dom.spec.whatwg.org/#dom-characterdata-appenddata

  }, {
    key: "appendData",
    value: function appendData(data) {
      this.replaceData(this.length, 0, data);
    } // https://dom.spec.whatwg.org/#dom-characterdata-insertdata

  }, {
    key: "insertData",
    value: function insertData(offset, data) {
      this.replaceData(offset, 0, data);
    } // https://dom.spec.whatwg.org/#dom-characterdata-deletedata

  }, {
    key: "deleteData",
    value: function deleteData(offset, count) {
      this.replaceData(offset, count, "");
    } // https://dom.spec.whatwg.org/#dom-characterdata-replacedata
    // https://dom.spec.whatwg.org/#concept-cd-replace

  }, {
    key: "replaceData",
    value: function replaceData(offset, count, data) {
      var length = this.length;

      if (offset > length) {
        throw DOMException.create(this._globalObject, ["The index is not in the allowed range.", "IndexSizeError"]);
      }

      if (offset + count > length) {
        count = length - offset;
      }

      queueMutationRecord(MUTATION_TYPE.CHARACTER_DATA, this, null, null, this._data, [], [], null, null);

      var start = this._data.slice(0, offset);

      var end = this._data.slice(offset + count);

      this._data = start + data + end;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this._referencedRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var range = _step.value;
          var _start = range._start,
              _end = range._end;

          if (_start.offset > offset && _start.offset <= offset + count) {
            range._setLiveRangeStart(this, offset);
          }

          if (_end.offset > offset && _end.offset <= offset + count) {
            range._setLiveRangeEnd(this, offset);
          }

          if (_start.offset > offset + count) {
            range._setLiveRangeStart(this, _start.offset + data.length - count);
          }

          if (_end.offset > offset + count) {
            range._setLiveRangeEnd(this, _end.offset + data.length - count);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (this.nodeType === TEXT_NODE && this.parentNode) {
        this.parentNode._childTextContentChangeSteps();
      }
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    },
    set: function set(data) {
      this.replaceData(0, this.length, data);
    } // https://dom.spec.whatwg.org/#dom-characterdata-length

  }, {
    key: "length",
    get: function get() {
      return this._data.length;
    }
  }]);

  return CharacterDataImpl;
}(NodeImpl);

mixin(CharacterDataImpl.prototype, NonDocumentTypeChildNodeImpl.prototype);
mixin(CharacterDataImpl.prototype, ChildNodeImpl.prototype);
module.exports = {
  implementation: CharacterDataImpl
};